import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

export const fmtPrice = (n) => `$${Number(n).toFixed(2)}`;

export function useGiftOffer() {
  const [offer, setOffer] = useState(null);
  useEffect(() => {
    axios.get(`${API}/gift-banner`).then((r) => setOffer(r.data)).catch(() => {});
  }, []);
  return offer;
}

export const isHolidayPrice = (offer) => !!offer && offer.gift_price < offer.regular_price;

export function endsInLabel(endsAt) {
  const ms = new Date(endsAt) - Date.now();
  if (ms <= 0) return null;
  const days = Math.ceil(ms / 86400000);
  if (days <= 1) {
    const hours = Math.max(1, Math.ceil(ms / 3600000));
    return `Holiday price ends in ${hours} hour${hours === 1 ? "" : "s"}`;
  }
  return `Holiday price ends in ${days} days`;
}
